import GamecenterNonScheduledLayout from '../../../../common/components/GamecenterNonScheduledLayout/GamecenterNonScheduledLayout';
import { EntryNameEditModalContextProvider } from '../../../../common/context/EntryNameEditModalContext/EntryNameEditModalContext';
import GamecenterModalsContextProvider from '../../../../common/context/GamecenterModalsContext/GamecenterModalsContextProvider';
import PlayerSurvivorStandingsPage from '../../../components/PlayerSurvivorStandingsPage/PlayerSurvivorStandingsPage';
import usePlayerSurvivorStandings from '../../../hooks/usePlayerSurvivorStandings';

function PlayerSurviorEntriesPageNonScheduled() {
  const { entries, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, error } =
    usePlayerSurvivorStandings({ isShowCurrentUserEntries: true });

  return (
    <GamecenterNonScheduledLayout>
      <GamecenterModalsContextProvider>
        <EntryNameEditModalContextProvider>
          <PlayerSurvivorStandingsPage
            entries={entries}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            fetchNextPage={fetchNextPage}
            isLoading={isLoading}
            error={error}
            page="entries"
          />
        </EntryNameEditModalContextProvider>
      </GamecenterModalsContextProvider>
    </GamecenterNonScheduledLayout>
  );
}

export default PlayerSurviorEntriesPageNonScheduled;
